import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

import { numberFormat } from '@/_shared/utils/utility';

import { LeftHeaderWithBack, type THeaderWithBack } from './left-header-with-back';
import { PageHeader } from './page-header';
import { StickyContainer } from './sticky-container';

export function StickyPageHeader({
  routes,
  title,
  children,
  backLink,
  isModal = false,
  recordCount,
}: PropsWithChildren<THeaderWithBack & { isModal?: boolean; recordCount?: number }>) {
  return (
    <StickyContainer className={twMerge(isModal ? 'top-0 mx-px rounded-t-3xl' : '')}>
      <PageHeader isModal={isModal}>
        <LeftHeaderWithBack
          title={`${title}${recordCount ? ` (${numberFormat(recordCount)})` : ''}`}
          routes={routes}
          backLink={isModal ? undefined : backLink}
        />
        {children}
      </PageHeader>
    </StickyContainer>
  );
}
